import SuppliersSelectDialog from './suppliersSelectDialog'
import CustomersSelectDialog from './customersSelectDialog'
import StoresSelectDialog from './storesSelectDialog'
import WorkmanshipSelectDialog from './workmanshipSelectDialog'

export default {
  install(Vue){
    //注册全局组件
    Vue.component('SuppliersSelectDialog',SuppliersSelectDialog);
    Vue.component('StoresSelectDialog',StoresSelectDialog);
    Vue.component('WorkmanshipSelectDialog',WorkmanshipSelectDialog);
    Vue.component('CustomersSelectDialog',CustomersSelectDialog);
    
  }
}